var exports = {
  "Q": "x112a1f60--4dba39--content",
};

module.exports = exports;
